import { kindOf } from "../lib/kinds.ts";
import styles from "./FileBadge.module.css";
import { Icon } from "./Icon.tsx";

type Size = "md" | "lg";

export function FileBadge({
  contentType,
  name,
  size = "md",
}: {
  contentType: string | null;
  name: string;
  size?: Size;
}) {
  const { kind, badge } = kindOf(contentType, name);
  return (
    <span className={styles.badge} data-kind={kind} data-size={size} aria-hidden="true">
      {badge}
    </span>
  );
}

export function FolderBadge({ size = "md" }: { size?: Size }) {
  return (
    <span className={styles.badge} data-kind="folder" data-size={size} aria-hidden="true">
      <Icon name="folder" />
    </span>
  );
}
